module.exports = __webpack_public_path__ + "img/download_img_app@2x.2fd4ac4e.png";